import React from 'react'
import { Button, Card } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import Layout from '../../home/theme/Layout'

const CartError = () => {
  const history = useHistory()

  return (
    <Layout title="Pago no completado">
      <div className="container py-4 py-lg-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <Card className="shadow-sm border-0">
              <Card.Body className="d-flex flex-column align-items-center text-center py-5 px-4">
                <i className="far fa-times-circle text-danger fa-4x mb-3" />

                <h1 className="h4 mb-2">
                  Pago no procesado
                </h1>

                <p className="text-muted mb-4">
                  Tu operación no pudo finalizarse correctamente.  
                  Es posible que el pago haya sido cancelado, rechazado por el banco
                  o se haya producido un error en la conexión.
                </p>

                <div className="d-flex flex-column flex-sm-row gap-2">
                  <Button
                    variant="primary"
                    className="mb-2 mb-sm-0 me-sm-2"
                    onClick={() => history.push('/carrito')}
                  >
                    Volver al carrito
                  </Button>

                  <Button
                    variant="outline-secondary"
                    onClick={() => history.push('/')}
                  >
                    Ver más eventos
                  </Button>
                </div>

                <p className="small text-muted mt-4 mb-0">
                  Si el cargo aparece en tu estado de cuenta y el problema persiste,
                  por favor contacta a nuestro soporte indicando el correo de tu compra.
                </p>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default CartError
